<template>
  <section class="section meet-section">
    <b-row>
      <b-col md="5" class="mt-5">
        <h2 class="display-4">Meet the Unstitched Community</h2>
        <p>
          Our community is the heart and soul of everything we do. Join it and
          help us build the platform you’ve always dreamed of.
        </p>

        <b-button
          class="btn-lg mt-5 mb-5 btn-discord"
          variant="accent"
          target="_blank"
          rel="noopener noreferrer"
          href="https://discord.gg/dzcC8mm"
        >
          Join our Discord Server
        </b-button>
      </b-col>

      <b-col offset-md="1" md="6">
        <div class="foo">
          <MeetImage />
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import MeetImage from "./assets/MeetImage";
export default {
  components: {
    MeetImage
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
.meet-section {
  color: $primary-blue;
  position: relative;
  padding-top: 75px;
}

.display-4 {
  font-weight: 300;
  font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/community/MeetSection.vue